<template>
  <v-layout class="restaurant-dashboard-container">
    <v-container fluid class="d-flex flex-column">
      <v-row align="stretch" class="flex-md-nowrap">
        <v-col cols="12" md="6" lg="6">
          <v-hover v-slot:default="{ hover }">
            <v-card
              class="restaurant-info fill-height"
              :elevation="hover ? 0 : 0"
            >
              <v-card-text class="py-0 fill-height">
                <v-row align="center" class="flex-nowrap fill-height">
                  <v-col cols="auto">
                    <router-link :to="`/${restaurant.stringId}/settings`">
                      <v-img
                        class="logo"
                        :src="
                          restaurant.logo
                            ? `${uploadsPath}/${restaurant.logo}`
                            : `assets/img/restaurant-logo.png`
                        "
                      ></v-img>
                    </router-link>
                  </v-col>
                  <v-col class="flex-fill">
                    <h3 class="name font-weight-light">
                      {{ restaurant.name }}
                    </h3>
                    <div class="d-flex align-center">
                      <a
                        class="link font-weight-light store-url"
                        target="_blank"
                        :href="`https://bistri.fi/go/${restaurant.id}`"
                        >bistri.fi/{{ restaurant.stringId }}</a
                      >
                      <v-btn
                        icon
                        x-small
                        class="ml-1"
                        @click="copyStoreUrl"
                        title="Copy URL"
                      >
                        <v-icon small>mdi-content-copy</v-icon>
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
                <div class="meta children-inline">
                  <router-link
                    :to="`/${restaurant.stringId}/settings?tab=plan`"
                  >
                    <v-chip
                      link
                      v-if="isPlanExpired"
                      label
                      small
                      color="red"
                      text-color="white"
                      >Vencido</v-chip
                    >
                    <v-chip
                      link
                      v-else-if="effectiveTier === 0"
                      label
                      small
                      color="green"
                      text-color="white"
                      >Lite</v-chip
                    >
                    <v-chip
                      link
                      v-else-if="effectiveTier === 1"
                      label
                      small
                      color="orange"
                      text-color="white"
                      >Plus</v-chip
                    >
                    <v-chip
                      link
                      v-else-if="effectiveTier === 2"
                      label
                      small
                      color="#ff6f00"
                      text-color="white"
                      >{{ currentPlan ? currentPlan.title : 'Pro' }}</v-chip
                    >
                  </router-link>
                  <v-btn icon :to="`/${restaurant.stringId}/settings`"
                    ><v-icon>mdi-cog</v-icon></v-btn
                  >
                </div>
              </v-card-text>
            </v-card>
          </v-hover>
        </v-col>
        <v-col cols="6" md="auto">
          <v-hover v-slot:default="{ hover }">
            <router-link :to="`/${restaurant.stringId}/categories`">
              <v-card class="" :elevation="hover ? 3 : 0">
                <v-card-text>
                  <v-row
                    class="main-stat"
                    justify="space-between"
                    align="center"
                  >
                    <v-col cols="auto">
                      <v-icon class="icon">mdi-menu</v-icon>
                    </v-col>
                    <v-col cols="auto">
                      <div class="content">
                        <span class="value">{{ categoryCount }}</span>
                        <span class="stat-title">{{
                          $t('restaurantDashboard.categories')
                        }}</span>
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </router-link>
          </v-hover>
        </v-col>
        <v-col cols="6" md="auto">
          <v-hover v-slot:default="{ hover }">
            <router-link :to="`/${restaurant.stringId}/items`">
              <v-card class="" :elevation="hover ? 3 : 0">
                <v-card-text>
                  <v-row
                    class="main-stat"
                    justify="space-between"
                    align="center"
                  >
                    <v-col cols="auto">
                      <v-icon class="icon">mdi-silverware</v-icon>
                    </v-col>
                    <v-col cols="auto">
                      <div class="content">
                        <span class="value">{{ itemCount }}</span>
                        <span class="stat-title">{{
                          $t('restaurantDashboard.items')
                        }}</span>
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </router-link>
          </v-hover>
        </v-col>
      </v-row>
      <v-row :style="{ order: newStore ? 1 : 'initial' }">
        <v-col cols="12" sm="6" md="6" lg="5">
          <v-hover v-slot:default="{ hover }">
            <v-card :elevation="hover ? 3 : 0" class="mb-6">
              <v-card-title class="py-2 font-weight-regular"> </v-card-title>
              <v-card-subtitle class="pb-1">Últimas novedades</v-card-subtitle>
              <v-card-text>
                <v-btn color="success" @click="openChangelog">
                  14/02 - Sistema de stock!
                </v-btn>
              </v-card-text>
            </v-card>
          </v-hover>
          <template
            v-if="
              restaurant.country === 'CO' && restaurant.createdAt < '2025-02-01'
            "
          >
            <v-hover v-slot:default="{ hover }">
              <v-card :elevation="hover ? 3 : 0">
                <v-card-title class="py-2 font-weight-regular"
                  >Bloqueo por parte de Claro Colombia</v-card-title
                >
                <v-card-text>
                  <p style="" class="mb-0">
                    Lamentamos escuchar que nuevamente Claro Colombia está
                    bloqueando QueResto.<br /><br />Nuestra recomendación para
                    Colombia en este momento, es
                    <b>re-generar los QR y cambiar los links al menú</b>. Los
                    nuevos QR utilizan un nuevo dominio, que redirige a
                    Bistrify.app en Colombia, y a QueResto.com en el resto del
                    mundo, de forma que saltea el bloqueo de Claro.<br /><br />En
                    el caso de los links, deben <b>reemplazar</b> la parte que
                    dice <b>"queresto.com" por "bistri.fi"</b>. <br /><br />Si
                    utiliza plugin de impresión y utiliza el panel desde el
                    nuevo dominio, debe descargar la última versión del mismo
                    para poder seguir utilizandolo.<br /><br />Al mismo tiempo,
                    agradecemos si pueden tomarse un momento para realizar la
                    queja con el servicio al cliente de Claro Colombia.<br /><br />Sabemos
                    que hacer el cambio es un trabajo engorroso, pero es la
                    única solución duradera y segura que permitirá trabajar sin
                    más interrupciones. Cualquier duda o consulta, puede
                    contactar a
                    <a href="mailto:info@queresto.com">info@queresto.com</a>
                  </p>
                </v-card-text>
              </v-card>
            </v-hover></template
          >
        </v-col>
        <v-col cols="12" sm="6" md="5" lg="4">
          <v-hover v-slot:default="{ hover }">
            <v-card :elevation="hover ? 3 : 0">
              <v-card-text>
                <RestaurantDashboardImprovement />
              </v-card-text>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
      <v-row :style="{ order: newStore ? 'initial' : 4 }">
        <v-col v-if="newStore" cols="12" sm="8" md="8" lg="7">
          <v-card class="" :elevation="0">
            <v-card-title>{{
              $t('restaurantDashboard.firstSteps')
            }}</v-card-title>
            <v-card-subtitle>{{
              $t('restaurantDashboard.firstSteps.subtitle')
            }}</v-card-subtitle>
            <v-card-text>
              <p class="grey--text">
                <b>Bienvenido a QueResto.com</b>, la mejor carta digital con
                código QR. <br />Como nuevo usuario, se le ha otorgado un
                <b>mes gratis del plan Plus</b>, lo que le permitirá entre otras
                cosas <b>recibir pedidos</b> tanto por esta plataforma como por
                WhatsApp. <br />Si no le interesan las funciones Plus, ¡no se
                preocupe! Una vez que pase el mes volverá a la versión Lite,
                la cual es gratis <b>de por vida</b>.
              </p>
              <v-row>
                <v-col cols="12">
                  <v-hover v-slot:default="{ hover }">
                    <router-link :to="`/${restaurant.stringId}/settings`">
                      <v-card class="step" :elevation="!hover ? 2 : 5">
                        <v-card-text>
                          <div class="step-inner">
                            <span class="step-number">1</span>
                            <v-icon class="step-icon">edit</v-icon>
                            <span class="step-title text-center d-block"
                              >Editar información</span
                            >
                          </div>
                        </v-card-text>
                      </v-card>
                    </router-link>
                  </v-hover>
                </v-col>
                <v-col cols="12">
                  <v-hover v-slot:default="{ hover }">
                    <router-link :to="`/${restaurant.stringId}/design`">
                      <v-card class="step" :elevation="!hover ? 2 : 5">
                        <v-card-text>
                          <div class="step-inner">
                            <span class="step-number">2</span>
                            <v-icon class="step-icon">mdi-palette</v-icon>
                            <span class="step-title text-center d-block"
                              >Editar diseño</span
                            >
                          </div>
                        </v-card-text>
                      </v-card>
                    </router-link>
                  </v-hover>
                </v-col>
                <v-col cols="12">
                  <v-hover v-slot:default="{ hover }">
                    <router-link :to="`/${restaurant.stringId}/categories`">
                      <v-card class="step" :elevation="!hover ? 2 : 5">
                        <v-card-text>
                          <div class="step-inner">
                            <span class="step-number">3</span>
                            <v-icon class="step-icon">mdi-menu</v-icon>
                            <span class="step-title text-center d-block">{{
                              $t('restaurantDashboard.stepCategories')
                            }}</span>
                          </div>
                        </v-card-text>
                      </v-card>
                    </router-link>
                  </v-hover>
                </v-col>
                <v-col cols="12">
                  <v-hover v-slot:default="{ hover }">
                    <router-link :to="`/${restaurant.stringId}/items`">
                      <v-card class="step" :elevation="!hover ? 2 : 5">
                        <v-card-text>
                          <div class="step-inner">
                            <span class="step-number">4</span>
                            <v-icon class="step-icon">mdi-silverware</v-icon>
                            <span class="step-title text-center d-block">{{
                              $t('restaurantDashboard.stepItems')
                            }}</span>
                          </div>
                        </v-card-text>
                      </v-card>
                    </router-link>
                  </v-hover>
                </v-col>
                <v-col cols="12">
                  <v-hover v-slot:default="{ hover }">
                    <router-link :to="`/${restaurant.stringId}/qr`">
                      <v-card class="step" :elevation="!hover ? 2 : 5">
                        <v-card-text>
                          <div class="step-inner">
                            <span class="step-number">5</span>
                            <v-icon class="step-icon">mdi-qrcode</v-icon>
                            <span class="step-title text-center d-block">{{
                              $t('restaurantDashboard.stepQr')
                            }}</span>
                          </div>
                        </v-card-text>
                      </v-card>
                    </router-link>
                  </v-hover>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="4" md="3" lg="2">
          <v-hover v-slot:default="{ hover }">
            <a :href="`https://bistri.fi/go/${restaurant.id}`" target="_blank">
              <v-card class="" :elevation="hover ? 3 : 0">
                <v-card-text class="pa-1">
                  <v-img class="preview-qr" v-if="qrUrl" :src="qrUrl" />
                  <div class="text-center font-weight-light">
                    {{ $t('qr.preview') }}
                  </div>
                </v-card-text>
              </v-card>
            </a>
          </v-hover>
        </v-col>
      </v-row>
      <v-row v-if="branches.length > 1">
        <v-col cols="12" lg="12" xl="10" class="ma-0">
          <v-toolbar class="rounded-toolbar" color="#e06f18" dense flat>
            <v-col class="px-0">
              <span
                class="white--text mr-2 children-inline mt-n1 d-inline-block font-weight-light"
              >
                <v-icon color="#fff" style="padding-bottom: 2px"
                  >mdi-store-outline</v-icon
                >
                <span style="padding-bottom: 2px">{{
                  'Sucursal' /*$t('branch')*/
                }}</span>
              </span>
              <v-select
                class="branch-select v-select--inline theme--dark v-select--no-black all-white"
                background-color="transparent"
                color="#fff"
                :items="branches"
                :value="branch"
                item-text="name"
                return-object
                solo-inverted
                flat
                hide-details
                dense
                @change="selectBranch"
              ></v-select>
            </v-col>
          </v-toolbar>
        </v-col>
      </v-row>
      <v-row style="order: 3">
        <v-col
          cols="12"
          md="6"
          lg="5"
          xl="4"
          v-for="widget of statWidgets"
          :key="widget.type"
        >
          <v-hover v-slot:default="{ hover }">
            <v-card class="stats-widget-container" :elevation="hover ? 2 : 0">
              <v-card-title class="widget-title font-weight-light">{{
                widget.title
              }}</v-card-title>
              <v-card-text class="pb-0">
                <stats-widget
                  :options="widget.options"
                  :stats="widget.stats"
                  @refresh="updateStats(widget)"
                >
                  <template #default>
                    <v-btn
                      text
                      color="primary"
                      :to="widget.statsLink"
                      class="font-weight-light mr-n3 px-1"
                      >Ver informe <v-icon>mdi-chevron-right</v-icon></v-btn
                    >
                  </template>
                </stats-widget>
              </v-card-text>
            </v-card>
          </v-hover>
        </v-col>
        <v-col cols="7" sm="4" md="4" lg="2" xl="2" v-if="effectiveTier > 0">
          <v-hover v-slot:default="{ hover }">
            <v-card class="orders-status-container" :elevation="hover ? 2 : 0">
              <v-card-title class="widget-title font-weight-light">
                <span>Estado</span>
                <v-spacer />
                <v-btn icon :to="`/${restaurant.stringId}/settings?tab=orders`"
                  ><v-icon>mdi-cog</v-icon></v-btn
                >
              </v-card-title>
              <v-card-text>
                <display-value title="Pedidos" space-between>
                  <v-icon small color="green" v-if="branch.allowOrders"
                    >mdi-check-circle</v-icon
                  >
                  <v-icon small color="#ddd" v-else>mdi-minus-circle</v-icon>
                </display-value>
                <template v-if="branch.allowOrders">
                  <display-value
                    title="Modalidad"
                    space-between
                    :client-bold="false"
                  >
                    <v-chip
                      small
                      dark
                      color="#ff6f00"
                      label
                      v-if="branch.ordersMode === 'native'"
                      class="font-weight-light"
                    >
                      <v-icon x-small class="mr-1">mdi-silverware</v-icon>
                      QueResto
                    </v-chip>
                    <v-chip
                      small
                      dark
                      color="#25d366"
                      label
                      v-else
                      class="font-weight-light"
                    >
                      <v-icon x-small class="mr-1">mdi-whatsapp</v-icon>
                      WhatsApp
                    </v-chip>
                  </display-value>
                  <display-value
                    title="Anónimos"
                    space-between
                    :client-bold="false"
                  >
                    <v-icon small color="green" v-if="branch.anonymousOrders"
                      >mdi-check-circle</v-icon
                    >
                    <v-icon small color="#ddd" v-else>mdi-minus-circle</v-icon>
                  </display-value>
                  <display-value
                    title="A la mesa"
                    space-between
                    :client-bold="false"
                  >
                    <v-icon small color="green" v-if="branch.tableOrders"
                      >mdi-check-circle</v-icon
                    >
                    <v-icon small color="#ddd" v-else>mdi-minus-circle</v-icon>
                  </display-value>
                  <display-value
                    title="Take away"
                    space-between
                    :client-bold="false"
                  >
                    <v-icon small color="green" v-if="branch.takeAway"
                      >mdi-check-circle</v-icon
                    >
                    <v-icon small color="#ddd" v-else>mdi-minus-circle</v-icon>
                  </display-value>
                  <display-value
                    title="Delivery"
                    space-between
                    :client-bold="false"
                  >
                    <v-icon small color="green" v-if="branch.delivery"
                      >mdi-check-circle</v-icon
                    >
                    <v-icon small color="#ddd" v-else>mdi-minus-circle</v-icon>
                  </display-value>
                </template>
              </v-card-text>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
    </v-container>
  </v-layout>
</template>

<script lang="ts">
  import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
  import { IRestaurant } from '../../interfaces/IRestaurant';
  import { Globals } from '../../modules/Globals';
  import RestaurantsService from '../../api/services/restaurants.service';
  import { createQrBase64 } from '../../utils';
  import StatsService from '../../api/services/stats.service';
  import { IBranch } from '../../interfaces/IBranch';
  import { StatType } from '../../enums/StatEnums';
  import StatsWidget from '../widgets/StatsWidget.vue';
  import { IStat } from '../../interfaces/IStat';
  import {
    OrderMode,
    OrderPaymentStatus,
    OrderStatus,
  } from '../../enums/OrderEnums';
  import { vueData } from '../../VueData';
  import DisplayValue from '../DisplayValue.vue';
  import OrderModal from '../modals/OrderModal.vue';
  import ChangelogModal from '../modals/ChangelogModal.vue';
  import RestaurantDashboardImprovement from '../restaurant/dashboard/RestaurantDashboardImprovement.vue';
  import { getTopLevelDomain } from '@/utils/domain.utils';
  import { AlertType } from '@/interfaces/IAlert';
  import {
    getEffectiveTier,
    isPlanExpired,
  } from '@/utils/billing-entitlements.utils';

  @Component({
    components: { DisplayValue, StatsWidget, RestaurantDashboardImprovement },
  })
  export default class RestaurantDashboard extends Vue {
    @Prop() restaurant: IRestaurant;
    @Prop() branches: IBranch[];
    @Prop() branch: IBranch;
    statsService = new StatsService();
    restaurantsService = new RestaurantsService();
    apiPath = Globals.apiPath;
    uploadsPath = Globals.uploadsPath;
    itemCount = 0;
    categoryCount = 0;
    qrUrl = null;
    loading = false;
    domain = getTopLevelDomain();

    get effectiveTier(): number {
      return getEffectiveTier(this.restaurant);
    }

    get isPlanExpired(): boolean {
      return isPlanExpired(this.restaurant?.planExpiresAt);
    }

    mounted() {
      this.init();
    }

    async init() {
      this.loading = true;
      this.qrUrl = await createQrBase64(
        `https://bistri.fi/go/${this.restaurant.id}`,
        200
      );

      this.restaurantsService
        .getHomeStats(this.restaurant.id)
        .then((homeStats) => {
          this.itemCount = homeStats.itemCount;
          this.categoryCount = homeStats.categoryCount;
          this.loading = false;
        });

      await this.initStats();
    }

    get newStore() {
      if (!this.restaurant) return false;

      const createdAt = new Date(this.restaurant.createdAt);
      const now = new Date();
      const diff = now.getTime() - createdAt.getTime();
      const diffHours = diff / 1000 / 60 / 60;
      return (
        diffHours < 48 ||
        (!this.loading && (this.itemCount === 0 || this.categoryCount === 0))
      );
    }

    @Watch('branch')
    onBranchChanged() {
      this.initStats();
    }

    openChangelog() {
      this.$modal.show(
        ChangelogModal,
        {
          restaurant: this.restaurant,
        },
        {
          name: 'changelog',
          classes: 'dialog--height-limit',
          adaptive: true,
          height: 'auto',
          width: 700,
          scrollable: true,
          maxWidth: window.innerWidth * 0.95,
        },
        {}
      );
    }

    statWidgets: {
      options: any;
      type: StatType;
      title: string;
      stats: IStat[];
    }[] = [];
    private async initStats() {
      this.statWidgets = [];

      const to = new Date(),
        from = new Date();
      from.setDate(from.getDate() - 1);

      const viewsWidget = {
        title: 'Vistas al menú',
        statsLink: `/${this.restaurant.stringId}/stats/views`,
        type: StatType.Views,
        options: {
          label: 'Vistas',
          from: new Date(from),
          to: new Date(to),
          interval: 'hour',
        },
        stats: null,
      };
      this.statWidgets.push(viewsWidget);

      if (
        this.effectiveTier > 0 &&
        this.branch.ordersMode === OrderMode.Native
      ) {
        const ordersWidget = {
          title: 'Pedidos',
          statsLink: `/${this.restaurant.stringId}/stats/orders`,
          type: StatType.Orders,
          options: {
            label: 'Pedidos',
            from: new Date(from),
            to: new Date(to),
            interval: 'hour',
          },
          stats: null,
        };
        this.statWidgets.push(ordersWidget);
      }

      for (const widget of this.statWidgets) {
        this.updateStats(widget);
      }
    }

    get currentPlan() {
      if (this.effectiveTier <= 0) return null;

      return Globals.plans.find(
        (value) =>
          value.tier === this.effectiveTier &&
          ((!this.restaurant.subTier && !value.subTier) ||
            value.subTier === this.restaurant.subTier)
      );
    }

    selectBranch(branch: IBranch) {
      vueData.setCurrentBranch(branch);
    }

    async updateStats(widget) {
      const options = widget.options;
      widget.stats = await this.statsService.getAll(
        this.restaurant.id,
        this.branch.id,
        widget.type,
        options.from,
        options.to
      );
    }

    copyStoreUrl() {
      const url = `https://bistri.fi/${this.restaurant.stringId}`;
      navigator.clipboard
        .writeText(url)
        .then(() => {
          vueData.addAlert('URL copied to clipboard!', AlertType.Success);
        })
        .catch((err) => {
          console.error('Failed to copy: ', err);
          vueData.addAlert('Failed to copy URL', AlertType.Error);
        });
    }
  }
</script>

<style lang="scss" scoped>
  .step {
    .step-inner {
      @apply tw-flex tw-items-center tw-space-x-2;

      .step-number {
        @apply tw-text-2xl tw-font-bold tw-text-gray-400;
      }

      .step-icon {
        @apply tw-text-2xl tw-text-gray-400;
      }

      .step-title {
        @apply tw-text-lg tw-text-gray-500;
      }
    }
  }
</style>
